import React from 'react';

import { Anchor } from '@atlaskit/primitives/compiled/anchor';

export default function Default(): React.JSX.Element {
	return <Anchor href="/components/primitives/overview">Anchor</Anchor>;
}
